import { render, staticRenderFns } from "./Lettres.vue?vue&type=template&id=025ce5db&scoped=true"
import script from "./Lettres.vue?vue&type=script&lang=js"
export * from "./Lettres.vue?vue&type=script&lang=js"
import style0 from "./Lettres.vue?vue&type=style&index=0&id=025ce5db&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "025ce5db",
  null
  
)

export default component.exports